import { store } from '@betacrew/jars-flux';
import { all, call, put, takeLatest, takeLeading } from 'redux-saga/effects';
import General from '../../../../../libs/utility/General';
import ReconciliationDataService from '../../../../../services/ReconciliationDataService';

import { TOASTER_VARIANT } from '../../../../components/toast/constants';
import { PAGE_STATE } from '../../../constants/constants';
import { addNotifications } from '../../../toaster/ToasterPortalSlice';
import { componentKey, setFormDataFromRecordId, setIsIncorrectFormRecordId, setIsReconciliationEditModeOn, setListRecords, setLoadingState, setOpenReconciliationPaymentDrawer, setReconciliationAmount, setScheduleReconciliationDate, setStateWitheldPaymentFrequency, setSuccessfullySubmittedReconciliation, setTempFormFieldsList, updateFormsPreLoadedData, updateUserInteractionPopupWResponseObj } from './SubmitReconciliationListingSlice';
import { RECONCILIATION_LOADING_STATES } from '../constants';

export const { getSubmitReconciliationGridRecords, getReconciliationFields, getReconciliationFormsPreloadedData, onDependentFieldChangeGetValues, saveReconciliation, viewReconciliationPDF, getReconciliationAmount, getReconFrequencyPopUpOption } = {
    getSubmitReconciliationGridRecords: (payload) => {
        return {
            type: "RECONCILIATION/SUBMIT_GET_RECORDS",
            payload: payload
        }
    },
    getReconciliationFields: (payload) => {
        return {
            type: "RECONCILIATION/GET_FIELDS",
            payload: payload
        }
    },
    getReconciliationFormsPreloadedData: (payload) => {
        return {
            type: "RECONCILIATION/GET_PRELOADED_DATA",
            payload: payload
        }
    },
    onDependentFieldChangeGetValues: (payload) => {
        return {
            type: "RECONCILIATION/ONDEPENDENT_FIELD_CHANGE_VALUES",
            payload: payload
        }
    },
    saveReconciliation: (payload) => {
        return {
            type: "RECONCILIATION/SAVE",
            payload: payload
        }
    },
    viewReconciliationPDF: (payload) => {
        return {
            type: "RECONCILIATION/VIEW_PDF",
            payload: payload
        }
    },
    getReconciliationAmount: (payload) => {
        return {
            type: "RECONCILIATION/GET_AMOUNT",
            payload: payload
        }
    },
    getReconFrequencyPopUpOption: (payload) => {
        return {
            type: "RECONCILIATION/GET_RECON_FREQUENCY_POPUP",
            payload: payload
        }
    },
}

function* getSubmitReconciliationGridRecordsAsync(action) {
    try {
        yield put(setLoadingState({ state: RECONCILIATION_LOADING_STATES.GRID_LOADING }));
        
        const response = yield ReconciliationDataService.getSubmitReconciliationListRecords(action.payload);
        
        if(response){
            if(response?.data?.Status){
                yield put(setListRecords([response?.data?.Data]));
            }else{
                yield put(addNotifications({
                    heading: "Failed to get the records",
                    message: response.data.Message,
                    variant: TOASTER_VARIANT.DANGER
                }));
            }
        }
    }catch(error) {
        console.log(error)
        yield put(addNotifications({
            heading: "Error",
            message: "We are facing some error. Please try again",
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: RECONCILIATION_LOADING_STATES.GRID_READY }));
    }
}

function* getReconciliationFieldsAsync(action){
    try {

        const {formName, taxYear, toCreateFormData, quarter, formsPreLoadedData, returnedFormRecordIdData, isFormEditMode} = action.payload;
        yield put(setLoadingState({ state: PAGE_STATE.LOADING, message: "Getting fields..." }));
        
        const response = yield ReconciliationDataService.getFormFields(formName, quarter);
        if(response?.data?.Status){
            const updatedFieldsList = response?.data?.Data.map((item) => {
                
                const prepopulateField = formsPreLoadedData.hasOwnProperty(item?.FrontEndSource) ? formsPreLoadedData[item?.FrontEndSource] : null;
                if(isFormEditMode && returnedFormRecordIdData.hasOwnProperty(item?.Name)){
                    return {
                        ...item,
                        inputValue: returnedFormRecordIdData[item?.Name],
                    }
                } else if(item.Name === "FormName"){
                    return {
                        ...item,
                        inputValue: toCreateFormData?.selectedForm?.FormId ?? null,
                    }
                }
                else if (!Array.isArray(prepopulateField) && typeof prepopulateField !== "object" && prepopulateField !== null) {
                    return {
                      ...item,
                      inputValue: prepopulateField,
                    };
                }
                return item;
            });
            yield put(setTempFormFieldsList(updatedFieldsList));
        }else if(response?.data?.Status === 0){
            yield put(addNotifications({
                heading: "Failed to get the fields",
                message: response.data.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    }catch(error) {
        console.log(error)
        yield put(addNotifications({
            heading: "Error",
            message: "We are facing some error. Please try again",
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }));
    }
}

function* getReconciliationFormsPreloadedDataAsync(action){
    try {
        const {formsPreLoadedData, getFormFieldsFlag, toCreateFormData, formName, payerId, taxYear, isFormEditMode, formRecordId, referenceid, state, quarter} = action.payload;
        yield put(setLoadingState({ state: PAGE_STATE.LOADING, message: "Getting data..." }));
        
        let recordIdResponse;
        let formPreLoadedDataResponse;

        if(isFormEditMode){
            recordIdResponse = yield call(ReconciliationDataService.getFormByRecordId, formName, formRecordId);
            formPreLoadedDataResponse = yield call(ReconciliationDataService.getReconciliationPreloadedData, formName, payerId, taxYear, referenceid, state, quarter);
        }else{
            formPreLoadedDataResponse = yield ReconciliationDataService.getReconciliationPreloadedData(formName, payerId, taxYear, referenceid, state, quarter);
        }

        let returnedFormRecordIdData = null;
        let stopHere = false;

        if(isFormEditMode){
            if(recordIdResponse?.data?.Status === 1){
                returnedFormRecordIdData = recordIdResponse?.data?.Data;
                yield put(setFormDataFromRecordId(returnedFormRecordIdData));
                if(returnedFormRecordIdData?.ScheduledDate){
                    yield put(setScheduleReconciliationDate(returnedFormRecordIdData?.ScheduledDate));
                }
            }else{
                yield put(addNotifications({
                    heading: "Error",
                    message: recordIdResponse?.data?.Message,
                    variant: TOASTER_VARIANT.DANGER
                }));
                yield put(setIsIncorrectFormRecordId(true));
                yield put(setIsReconciliationEditModeOn(false));
                stopHere = true;
            }
        }
        if(!stopHere){
            if(formPreLoadedDataResponse?.data?.Status === 0){
                yield put(addNotifications({
                    heading: "Error",
                    message: formPreLoadedDataResponse?.data?.Message,
                    variant: TOASTER_VARIANT.DANGER
                }));
            }else{
                let tempFormsPreLoadedData = {};
                const returnedFormData = formPreLoadedDataResponse?.data?.Data ?? {};
                for (const key in returnedFormData) {
                    if(returnedFormData[key]){
                        tempFormsPreLoadedData[key] = returnedFormData[key];
                    }
                }
                yield put(updateFormsPreLoadedData({...tempFormsPreLoadedData}));
    
                if(getFormFieldsFlag){
                    yield call(getReconciliationFieldsAsync, { payload: { formName: formName, taxYear: taxYear, toCreateFormData: toCreateFormData, quarter: quarter, formsPreLoadedData: {
                        ...formsPreLoadedData,
                        ...tempFormsPreLoadedData,
                    },
                    returnedFormRecordIdData: returnedFormRecordIdData,
                    isFormEditMode: isFormEditMode,
                 } });
                }
            }
        }
    }catch(error){
        console.log(error)
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    }finally {
        yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }))
    }
}

function* onDependentFieldChangeGetValuesAsync(action){
    try {
        yield put(setLoadingState({ state: PAGE_STATE.LOADING, message: "Updating dependent fields..." }));
        const response = yield ReconciliationDataService.calculateInferredValues(action.payload);
        if(response){
            if(response?.data?.Status === 0){
                yield put(addNotifications({
                    heading: "Error",
                    message: response?.data?.Message,
                    variant: TOASTER_VARIANT.DANGER
                }));
            }else{
                if(response?.data?.Data?.interaction){
                    yield put(updateUserInteractionPopupWResponseObj({
                        ...response.data.Data.interaction
                    }));
                }
            }
        }
        const responseDataArray = response?.data?.Data?.allFields ?? [];
        yield put(setTempFormFieldsList(responseDataArray));
    } catch(error) {
        console.log(error)
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    }finally {
        yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }))
    }
}

function* saveReconciliationAsync(action){
    try {
        const {formData} = action.payload;
        yield put(setLoadingState({ state: PAGE_STATE.LOADING, message: "Saving reconciliation..." }));
        const response = yield ReconciliationDataService.saveReconciliation(formData);
        if(response){
            if(response?.data?.Status === 0){
                yield put(addNotifications({
                    heading: "Error",
                    message: response?.data?.Message,
                    variant: TOASTER_VARIANT.DANGER
                }));
            }else{
                yield put(addNotifications({
                    heading: "Success",
                    message: "Successfully saved reconciliation",
                    variant: TOASTER_VARIANT.SUCCESS
                }));
                yield put(setSuccessfullySubmittedReconciliation(true));
            }
        }
    } catch(error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    }finally {
        yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }))
    }
}

function* viewReconciliationPDFAsync(action){
    try {
        const {formId, state, formName} = action.payload;
        yield put(setLoadingState({ state: RECONCILIATION_LOADING_STATES.GRID_LOADING }));
        const response = yield ReconciliationDataService.getReconciliationPDF(formId, state, formName);
        if(response){
            if(response?.data?.Status === 0){
                yield put(addNotifications({
                    heading: "Error",
                    message: response?.data?.Message,
                    variant: TOASTER_VARIANT.DANGER
                }));
            }else{
                General.openBase64FileInNewTab(response?.data?.Data.Base64, response?.data?.Data.Name);
            }
        }
    } catch(error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    }finally {
        yield put(setLoadingState({ state: RECONCILIATION_LOADING_STATES.GRID_READY }))
    }
}

function* getReconciliationAmountAsync(action){
    try {
        const {payerId, referenceIds, formName, state, reconciliationFormId, taxYear} = action.payload;
        yield put(setLoadingState({ state: RECONCILIATION_LOADING_STATES.GRID_LOADING }));
        const response = yield ReconciliationDataService.getReconciliationAmount(payerId, referenceIds, formName, state, reconciliationFormId, taxYear);
        if(response){
            if(response?.data?.Status === 0){
                yield put(addNotifications({
                    heading: "Error",
                    message: response?.data?.Message,
                    variant: TOASTER_VARIANT.DANGER
                }));
            }else{
                yield put(setReconciliationAmount(response?.data?.Data));
                yield put(setOpenReconciliationPaymentDrawer(true));
            }
        }
    } catch(error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    }finally {
        yield put(setLoadingState({ state: RECONCILIATION_LOADING_STATES.GRID_READY }))
    }
}

function* getReconFrequencyPopUpOptionAsync(action){
    try {
        yield put(setLoadingState({ state: RECONCILIATION_LOADING_STATES.GRID_LOADING }));
        const response = yield ReconciliationDataService.getReconFrequencyPopUpOption();
        yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }));
        if(response){
            if(response?.data?.Status === 0){
                yield put(addNotifications({
                    heading: "Error",
                    message: response?.data?.Message,
                    variant: TOASTER_VARIANT.DANGER
                }));
            }else{
                yield put(setStateWitheldPaymentFrequency(response?.data?.Data.forms));
            }
        }
    } catch(error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    }finally {
        yield put(setLoadingState({ state: RECONCILIATION_LOADING_STATES.GRID_READY }))
    }
}

function* rootSaga() {
    yield all([
        takeLatest(getSubmitReconciliationGridRecords().type, getSubmitReconciliationGridRecordsAsync),
        takeLatest(getReconciliationFields().type, getReconciliationFieldsAsync),
        takeLatest(getReconciliationFormsPreloadedData().type, getReconciliationFormsPreloadedDataAsync),
        takeLatest(onDependentFieldChangeGetValues().type, onDependentFieldChangeGetValuesAsync),
        takeLatest(saveReconciliation().type, saveReconciliationAsync),
        takeLatest(viewReconciliationPDF().type, viewReconciliationPDFAsync),
        takeLatest(getReconciliationAmount().type, getReconciliationAmountAsync),
        takeLatest(getReconFrequencyPopUpOption().type, getReconFrequencyPopUpOptionAsync),
    ]);
}
store.sagaManager.addSaga(componentKey, rootSaga);